module.exports = __webpack_public_path__ + "static/media/logo-min.48b9b2c0.svg";